import AlfaBetaForms from "../components/subforms/alfaBetaForms";
import GammaForm from "../components/subforms/gammaForm";
import { mapBackgroundForm } from "./helpers";
import {
  BackgroundMappingType,
  IFormNewBackground,
} from "@app/types/background.types";

export enum PROCESS_OPTIONS_VALUE {
  ALFA = "A",
  BETA = "B",
  GAMMA = "G",
}

export const PROCESS_OPTIONS = [
  { value: PROCESS_OPTIONS_VALUE.ALFA, label: "Alfa" },
  { value: PROCESS_OPTIONS_VALUE.BETA, label: "Beta" },
  { value: PROCESS_OPTIONS_VALUE.GAMMA, label: "Gamma" },
];

export enum MEDIO_FILTER_VALUE {
  MEDIO = "M",
  COMPLETO = "C",
}

export const MEDIO_FILTER_OPTIONS = [
  { value: MEDIO_FILTER_VALUE.MEDIO, label: "Medio" },
  { value: MEDIO_FILTER_VALUE.COMPLETO, label: "Completo" },
];

export const setsBackgroundForm: {
  type: string;
  component: React.ElementType<any>;
  counting_time: number;
  mapping?: (payload: IFormNewBackground) => BackgroundMappingType;
}[] = [
  {
    type: PROCESS_OPTIONS[0].value,
    component: AlfaBetaForms,
    counting_time: 3500,
    mapping: mapBackgroundForm,
  },
  {
    type: PROCESS_OPTIONS[1].value,
    component: AlfaBetaForms,
    counting_time: 3500,
    mapping: mapBackgroundForm,
  },
  {
    type: PROCESS_OPTIONS[2].value,
    component: GammaForm,
    counting_time: 200000,
    mapping: mapBackgroundForm,
  },
];

export enum TYPE_RESULT_TABLE {
  CHANGE = "CAMBIAR",
  KEEP = "MANTENER",
}
